// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1c02ab01255008cc1a0b","655":"a17d5717ea2635eff494"}[chunkId] + ".js";
};